export default __webpack_public_path__ + "static/media/09.35a91163.jpg";